import { createSlice } from "@reduxjs/toolkit";
import { setSearchStringReducer } from "../search/reducer";
import { commonFilters } from "./common-filters/common-filters";
import { setCommonFilterValueReducer } from "./common-filters/set-common-filter/reducer";
import { addCustomFiltersReducer } from "./custom-filters/add-custom-filters/reducer";
import { clearCustomFiltersReducer } from "./custom-filters/clear-custom-filters/reducer";
import { setCustomFilterAllValuesReducer } from "./custom-filters/set-custom-filter-all-values/reducer";
import { setCustomFilterGroupValueReducer } from "./custom-filters/set-custom-filter-group/reducer";
import { setCustomFilterValueReducer } from "./custom-filters/set-custom-filter-value/reducer";
import { deleteDiagnosticFilterValueReducer } from "./diagnostic-filters/delete/reducer";
import { setDiagnosticFilterValuesReducer } from "./diagnostic-filters/set/reducer";
import { IActivityHistoryFilter } from "./model";
import { resetFiltersReducer } from "./reset/reducer";
import { addUpFiltersReducer } from "./up-filters/add/reducer";
import { setUpFilterValuesReducer } from "./up-filters/set/reducer";

export const activityHistoryFiltersSlice = createSlice({
  name: "activity-history-filters",
  initialState: {
    searchString: "",
    filters: [...commonFilters] as IActivityHistoryFilter[],
  },
  reducers: {
    setSearchString: setSearchStringReducer,
    setCommonFilterValue: setCommonFilterValueReducer,
    addCustomFilters: addCustomFiltersReducer,
    clearCustomFilters: clearCustomFiltersReducer,
    setCustomFilterGroupValue: setCustomFilterGroupValueReducer,
    setCustomFilterValue: setCustomFilterValueReducer,
    setCustomFilterAllValues: setCustomFilterAllValuesReducer,
    setDiagnosticFilterValues: setDiagnosticFilterValuesReducer,
    deleteDiagnosticFilterValue: deleteDiagnosticFilterValueReducer,
    addUpFilters: addUpFiltersReducer,
    setUpFilterValues: setUpFilterValuesReducer,
    resetFilters: resetFiltersReducer,
  },
});
